module.exports = __webpack_public_path__ + "img/oaknest-2.9c23e69e.jpeg";